@if (visible) {
    <div class="onboarding-guide" [hidden]="obscured" (keydown.escape)="minimise(); $event.stopPropagation()">
        @if (expanded) {
            <section #panel id="onboarding-guide-panel" class="guide-panel mat-elevation-z8" role="region" aria-labelledby="onboarding-guide-title" tabindex="-1">
                <header class="guide-heading">
                    <div>
                        <p class="guide-eyebrow">Onboarding guide</p>
                        <h2 id="onboarding-guide-title">{{ guide.title || 'Create your first report' }}</h2>
                    </div>
                    <button mat-icon-button type="button" (click)="minimise()" aria-label="Minimise onboarding guide" matTooltip="Minimise"><mat-icon>remove</mat-icon></button>
                </header>
                <div class="guide-body">
                    @if (guide.message) {
                        <p class="guide-message">{{ guide.message }}</p>
                    }
                    @if (guide.tasks.length) {
                        <div class="guide-progress"><span>{{ guide.completed }} of {{ guide.total }} tasks completed</span><strong>{{ guide.percentage }}%</strong></div>
                        <mat-progress-bar mode="determinate" [value]="guide.percentage" aria-label="Onboarding progress"></mat-progress-bar>
                        <div class="guide-tasks" aria-label="Onboarding tasks">
                            @for (task of guide.tasks; track task.key) {
                                <button mat-button type="button" class="guide-task" [class.guide-task--selected]="selected === task.key" [class.guide-task--completed]="task.completed" [attr.aria-current]="task.key === guide.next_task ? 'step' : null" [attr.aria-label]="task.title + (task.completed ? ', completed' : ', not yet completed') + ', show me where'" (click)="selectTask(task)" [disabled]="saving">
                                    <mat-icon class="guide-task-status" aria-hidden="true">{{ task.completed ? 'check_circle' : 'radio_button_unchecked' }}</mat-icon>
                                    <span class="guide-task-title">{{ task.title }}</span>
                                    @if (task.key === guide.next_task && !task.completed) { <span class="guide-next-label" aria-hidden="true">Next</span> }
                                    <mat-icon class="guide-task-arrow" iconPositionEnd aria-hidden="true">chevron_right</mat-icon>
                                </button>
                            }
                        </div>
                    }
                    @if (selectedTask; as task) {
                        <div class="guide-detail">
                            <h3>{{ task.title }}</h3>
                            <p>{{ task.description }}</p>
                            <button mat-flat-button color="primary" type="button" (click)="selectTask(task)" [disabled]="saving">{{ actionLabel(task) }}<mat-icon iconPositionEnd aria-hidden="true">arrow_forward</mat-icon></button>
                        </div>
                    }
                    <button mat-button type="button" class="guide-hide" (click)="hide()" [disabled]="saving">Hide guide</button>
                </div>
            </section>
        }
        <div class="guide-launcher-shell mat-elevation-z4">
            <button #launcher data-onboarding-launcher mat-button type="button" class="guide-launcher" [attr.aria-expanded]="expanded" aria-controls="onboarding-guide-panel" [attr.aria-label]="(expanded ? 'Minimise' : 'Open') + ' onboarding guide' + (guide.tasks.length ? ', ' + guide.percentage + ' percent completed' : '')" (click)="expanded ? minimise() : open()">
                <mat-icon>checklist</mat-icon>
                <span class="guide-launcher-copy"><strong>Get started</strong><span>{{ guide.tasks.length ? guide.percentage + '% complete' : 'View guidance' }}</span></span>
            </button>
            @if (guide.tasks.length) {
                <mat-progress-bar class="guide-launcher-progress" mode="determinate" [value]="guide.percentage" aria-hidden="true"></mat-progress-bar>
            }
        </div>
    </div>
}
